module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-create-warehouses-out/master-create-warehouses-out.component.scss
// module id = ./src/app/master/master-create-warehouses-out/master-create-warehouses-out.component.scss
// module chunks = main